import { User } from "./user.ts";
import CryptoJS from "crypto-js";
import { Patient } from "./patient.ts";
import { ExportV2 } from "@robin/common";

export interface PatientData {
  deviceId: string;
  exportDate: Date;
  exportId: string;
  data: ExportV2.ExportData;
}

//this is the PatientData record that is stored
export interface PatientDataRecord {
  exportId: string;
  userId: string;
  patientId: string;
  deviceId: string;
  exportDate: Date;
  encryptedPart: string;
}

export const encryptPatientData = (
  record: PatientData,
  patient: Patient,
  user: User
) => {
  const key = user.cypherKey.map((byte) => String.fromCharCode(byte)).join("");
  const encryptedPart = CryptoJS.AES.encrypt(
    JSON.stringify(record.data),
    key
  ).toString();
  const patientDataRecord: PatientDataRecord = {
    ...record,
    patientId: patient.id,
    userId: user.userId,
    encryptedPart,
  };
  return patientDataRecord;
};

export const decryptPatientDataRecord = (
  record: PatientDataRecord,
  user: User
) => {
  const key = user.cypherKey.map((byte) => String.fromCharCode(byte)).join("");

  const { exportId, deviceId, exportDate } = record;
  const dataString = CryptoJS.AES.decrypt(record.encryptedPart, key).toString(
    CryptoJS.enc.Utf8
  );
  const data = JSON.parse(dataString);

  const patient: PatientData = {
    exportId,
    deviceId,
    exportDate,
    data,
  };
  return patient;
};
